import classNames from "classnames";
import { ButtonBase, Icon } from "client/Components";
import { forwardRef, ReactElement, Ref } from "react";
import styles from "./AddElementButton.module.less";

export type AddColumnButtonProps = {
	trackingId?: string;
	isActive?: boolean;
	onClick: () => void;
};

export const AddElementButton = forwardRef(
	(props: AddColumnButtonProps, ref: Ref<HTMLButtonElement>): ReactElement => {
		const {
			trackingId,
			isActive,
			onClick
		} = props;

		return (
			<ButtonBase
				ref={ref}
				className={classNames(
					styles.root,
					{[styles.root_active]: isActive}
				)}
				onClick={onClick}
				trackingId={trackingId}
			>
				<Icon
					value="plus"
					size="extra-extra-large"
				/>
			</ButtonBase>
		);
	}
);

AddElementButton.displayName = "AddElementButton";